import React, { useEffect, useState } from "react";
import { getMedias } from "../../../../services/media.service";
import _ from "lodash";
import {
  FileAddOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import EditMedia from "./EditMedia";
import parseMediaUrl from "../../../shared/functions/parseMediaUrl";
import MediaDescriptionRender from "./MediaDescriptionRender";
import { deleteMediaByUuid } from "../../../../services/backend/api.service";
import { Button, notification, Pagination } from "antd";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "../../../../stores/globalBackendStore";

const LIMIT = 8;

export default (props) => {
  const { t } = useTranslation();
  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const [refreshData, setRefreshData] = useState(false);
  const {
    group,
    onSelect,
    initialActiveGroup,
    visibleEdit,
    setVisibleEdit,
    editData,
    setEditData,
    onUploadNew,
  } = props;
  const [images, setImages] = useState([]);
  const [imagesMetadata, setImagesMetadata] = useState({
    hasNextPage: true,
    hasPrevPage: false,
    limit: LIMIT,
    nextPage: 1,
    page: 1,
    pagingCounter: 1,
    prevPage: null,
    totalDocs: null,
    totalPages: null,
  });
  const refreshDataList = ({ group, page, limit }) => {
    getMedias("image", { group, page, limit }).then((data) => {
      const apiItems = _.get(data, "data.docs", []);
      console.log("apiItems: ", apiItems);
      const { docs, ...apiMetadata } = _.get(data, "data", {});
      setImagesMetadata(apiMetadata);
      if (group == "_default") {
        setImages(apiItems);
      } else {
        const filtered = _.filter(apiItems, (item) => {
          if (initialActiveGroup && !group) {
            return (
              item.group === initialActiveGroup || initialActiveGroup === "0"
            );
            // return item.group === group || _.isEmpty(group);
          } else {
            return item.group === group;
          }
        });
        setImages(filtered);
      }

      setRefreshData(false);
    });
  };

  useEffect(() => {
    if (!visibleEdit) {
      refreshDataList({
        group,
        page: 1,
        limit: LIMIT,
      });
      setImagesMetadata({ ...imagesMetadata, page: 1, limit: LIMIT });
    }
  }, [group, visibleEdit]);

  useEffect(() => {
    if (refreshData) {
      refreshDataList({
        group,
        page: imagesMetadata.page,
        limit: imagesMetadata.limit,
      });
    }
  }, [refreshData]);

  const handleSelection = (e, item) => {
    props.onSelect(e, item);
  };

  const handleDelete = async (e, item) => {
    await deleteMediaByUuid({
      uuid: item.uuid,
    }).catch((err) => {
      notification["warning"]({
        message: t("Warning"),
        description: t("Media removing problem: ") + err.message,
        placement: "topRight",
      });
    });

    refreshDataList({ group, page: 1, limit: LIMIT });
    setImagesMetadata({ ...imagesMetadata, page: 1, limit: LIMIT });

    notification["success"]({
      message: t("Success"),
      description: t("Media has been deleted."),
      placement: "topRight",
    });
  };

  const openEdit = (e, item) => {
    setEditData(item);
    setVisibleEdit(true);
  };
  const paginationChange = (page, pageSize) => {
    refreshDataList({ group, page, limit: pageSize });
  };
  return (
    <>
      <div className={"media-images-list media-images-list--pagiantion"}>
        <EditMedia
          visibleEdit={visibleEdit}
          setVisibleEdit={setVisibleEdit}
          editData={editData}
          setRefreshData={setRefreshData}
          accept={_.get(apiSetup, `mediaLibrary.accept.image`)}
          onUploadNew={onUploadNew}
        />
        {images.map((item, key) => {
          const updatedAtPrefix = new Date(item.updatedAt).getTime();
          return (
            <div key={item.uuid} className={"media-item"}>
              <div className={"media-actions"}>
                <DeleteOutlined
                  style={{ color: "red" }}
                  onClick={(e) => {
                    handleDelete(e, item);
                  }}
                />

                <EditOutlined
                  onClick={(e) => {
                    openEdit(e, item);
                  }}
                />
              </div>
              <div
                className={"media-item-av"}
                onClick={(e) => handleSelection(e, item)}
              >
                <img
                  src={
                    parseMediaUrl(item.url) + `?updated_at=${updatedAtPrefix}`
                  }
                />
              </div>
              <div className={"media-item-data"}>
                <MediaDescriptionRender item={item} />
              </div>
            </div>
          );
        })}
      </div>
      <div className="pagination-container">
        <Pagination
          onChange={paginationChange}
          current={imagesMetadata.page}
          total={imagesMetadata.totalDocs}
          defaultPageSize={imagesMetadata.limit}
          hideOnSinglePage
        />
      </div>
    </>
  );
};
